import React from 'react';
import PropTypes from 'prop-types';
import { USER_ROLES, USER_ROLE_ORDER, canInviteRole, roleLabel } from '../../auth/permissions';

export default function RoleSelector({ actor, value, onChange, disabled = false, includeAdmin = true }) {
  const options = USER_ROLE_ORDER.filter(role => (includeAdmin || role !== USER_ROLES.ADMIN))
    .filter(role => canInviteRole(actor, role));

  return (
    <select
      id="invite_role"
      className="form-select"
      value={value}
      onChange={e => onChange(e.target.value)}
      disabled={disabled}
    >
      {options.map(role => (
        <option key={role} value={role}>
          {roleLabel(role)}
        </option>
      ))}
    </select>
  );
}

RoleSelector.propTypes = {
  actor: PropTypes.shape({
    role: PropTypes.string,
  }),
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  includeAdmin: PropTypes.bool,
};

RoleSelector.defaultProps = {
  actor: null,
  disabled: false,
  includeAdmin: true,
};
